import { Controller, useFormContext } from "react-hook-form";

import { Card } from "src/base-components/Card";
import { FormItem } from "src/base-components/FormItem";
import { Input } from "src/base-components/Input";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
};

export const AgentSelectionEditor: React.FC<Props> = ({ immutable }) => {
  const { control } = useFormContext<AgentNodeData>();

  return (
    <Card className="w-full pb-4 pt-4">
      <div className="space-y-4">
        <FormItem>
          <FormItem.Label
            className="mb-2"
            description="The unique identifier of the agent to invoke."
          >
            Agent ID
          </FormItem.Label>
          <Controller
            control={control}
            name="agent_id"
            render={({ field }) => (
              <Input
                data-loc="agent-id-input"
                disabled={immutable}
                placeholder="Enter agent ID (UUID)"
                value={field.value as string}
                fullWidth
                onChange={field.onChange}
              />
            )}
          />
        </FormItem>

        <FormItem>
          <FormItem.Label
            className="mb-2"
            description="The specific version of the agent to invoke."
          >
            Agent Version ID
          </FormItem.Label>
          <Controller
            control={control}
            name="agent_version_id"
            render={({ field }) => (
              <Input
                data-loc="agent-version-id-input"
                disabled={immutable}
                placeholder="Enter agent version ID (UUID)"
                value={field.value as string}
                fullWidth
                onChange={field.onChange}
              />
            )}
          />
        </FormItem>
      </div>
    </Card>
  );
};
